import React, { useEffect, useState, useRef } from "react";
import { Container, Row, Col, Card, Button, Form, Alert, Badge, Spinner, Table } from "react-bootstrap";
import { salvarMensagemPronta, carregaMensagensProntas, deletarMensagemPronta } from "../data/api/gsConnectApi";
import { useHistory } from 'react-router-dom';

function MensagensProntasView() {
  const [mensagens, setMensagens] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingAdd, setLoadingAdd] = useState(false);
  const [mensagemSucesso, setMensagemSucesso] = useState('');
  const [mensagemErro, setMensagemErro] = useState('');
  const mensagemRef = useRef(null);

  useEffect(() => {
    carregarMensagens();
  }, []);

  const carregarMensagens = async () => {
    setLoading(true);
    try {
      const dados = await carregaMensagensProntas();
      setMensagens(Array.isArray(dados) ? dados : []);
    } catch (error) {
      console.error('Erro ao carregar mensagens:', error);
      showError('Erro ao carregar mensagens prontas.');
    } finally {
      setLoading(false);
    }
  };

  const showSuccess = (message) => {
    setMensagemSucesso(message);
    setTimeout(() => setMensagemSucesso(''), 3000);
  };

  const showError = (message) => {
    setMensagemErro(message);
    setTimeout(() => setMensagemErro(''), 5000);
  };

  const adicionarMensagem = async () => {
    const conteudo = mensagemRef.current?.value?.trim();
    
    if (!conteudo) {
      showError('Por favor, digite uma mensagem.');
      return;
    }

    setLoadingAdd(true);
    try {
      await salvarMensagemPronta(conteudo);
      showSuccess('Mensagem adicionada com sucesso!');
      mensagemRef.current.value = '';
      await carregarMensagens();
    } catch (error) {
      console.error('Erro ao salvar mensagem:', error);
      showError('Erro ao salvar mensagem.');
    } finally {
      setLoadingAdd(false);
    }
  };

  const deletarMensagem = async (mensagem, index) => {
    if (!window.confirm('Tem certeza que deseja excluir esta mensagem?')) {
      return;
    }

    try {
      await deletarMensagemPronta(mensagem.id);
      const novasMensagens = [...mensagens];
      novasMensagens.splice(index, 1);
      setMensagens(novasMensagens);
      showSuccess('Mensagem excluída com sucesso!');
    } catch (error) {
      console.error('Erro ao excluir mensagem:', error);
      showError('Erro ao excluir mensagem.');
    }
  };

  const copiarMensagem = (conteudo) => {
    navigator.clipboard.writeText(conteudo).then(() => {
      showSuccess('Mensagem copiada para a área de transferência!');
    }).catch(() => {
      showError('Erro ao copiar mensagem.');
    });
  };

  const statCards = [
    { value: mensagens.length, label: 'Total de Mensagens', icon: '💬', color: '#43a047' },
    { value: mensagens.filter(m => m.conteudo && m.conteudo.length > 100).length, label: 'Mensagens Longas', icon: '📄', color: '#2e7d32' },
    { value: mensagens.filter(m => m.conteudo && m.conteudo.includes('*')).length, label: 'Com Formatação', icon: '✨', color: '#388e3c' },
    { value: mensagens.filter(m => m.conteudo && m.conteudo.includes('$')).length, label: 'Com Variáveis', icon: '🔧', color: '#4caf50' }
  ];

  const history = useHistory();

  return (
    <div style={{backgroundColor: '#f8f9fa', minHeight: '100vh'}}>
      {/* Header seguindo padrão */}
      <div style={{backgroundColor: '#198754', color: 'white', padding: '12px 20px', fontSize: '16px', fontWeight: '500'}}>
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <Button variant="outline-light" size="sm" style={{borderColor: 'white', color: 'white', marginRight: 12}} onClick={() => history.push('/admin/home')}>
              ← Voltar
            </Button>
            <span>Mensagens Prontas</span>
          </div>
          <Badge bg="primary" className="px-3 py-2">
            {mensagens.length} {mensagens.length === 1 ? 'mensagem' : 'mensagens'}
          </Badge>
        </div>
      </div>

      <Container fluid className="p-3">
        {/* Alerts */}
        {mensagemSucesso && (
          <Alert variant="success" className="mb-3" dismissible onClose={() => setMensagemSucesso('')}>
            ✅ {mensagemSucesso}
          </Alert>
        )}
        {mensagemErro && (
          <Alert variant="danger" className="mb-3" dismissible onClose={() => setMensagemErro('')}>
            ❌ {mensagemErro}
          </Alert>
        )}

        {/* Cards de Estatísticas - só mostra se tem dados */}
        {mensagens.length > 0 && (
          <Row className="mb-3">
            {statCards.map((stat, index) => (
              <Col md={3} key={index} className="mb-3">
                <Card className="text-center h-100" style={{backgroundColor: stat.color, color: 'white'}}>
                  <Card.Body className="py-3">
                    <div style={{fontSize: '2rem', marginBottom: '8px'}}>{stat.icon}</div>
                    <h4 className="mb-1">{stat.value}</h4>
                    <small>{stat.label}</small>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        )}

        {/* Card de Adição de Mensagem */}
        <div className="bg-white p-3 mb-3" style={{border: '1px solid #dee2e6'}}>
          <h6 className="mb-3" style={{color: '#198754', fontWeight: '600'}}>➕ Adicionar Nova Mensagem</h6>
          <Row className="align-items-end">
            <Col md={10}>
              <Form.Label className="small fw-medium text-muted">Conteúdo da mensagem</Form.Label>
              <Form.Control
                ref={mensagemRef}
                as="textarea"
                rows={4}
                placeholder="Digite sua mensagem pronta aqui..."
                style={{fontSize: '13px'}}
                onKeyDown={(e) => {
                  if (e.ctrlKey && e.key === 'Enter') {
                    adicionarMensagem();
                  }
                }}
              />
              <Form.Text className="text-muted">
                💡 Dica: Use Ctrl+Enter para adicionar rapidamente
              </Form.Text>
            </Col>
            <Col md={2}>
              <Button
                variant="success"
                onClick={adicionarMensagem}
                disabled={loadingAdd}
                style={{
                  backgroundColor: '#198754', 
                  borderColor: '#198754', 
                  fontSize: '13px', 
                  color: 'white',
                  width: '100%'
                }}
              >
                {loadingAdd ? <Spinner size="sm" /> : 'Adicionar'}
              </Button>
            </Col>
          </Row>
        </div>

        {/* Tabela de Mensagens */}
        <div className="bg-white" style={{border: '1px solid #dee2e6'}}>
          <div style={{backgroundColor: '#198754', color: 'white', padding: '12px 16px'}}>
            <h6 className="mb-0" style={{fontWeight: '500'}}>📋 Lista de Mensagens Prontas</h6>
          </div>
          
          {loading ? (
            <div className="text-center py-5">
              <Spinner animation="border" style={{color: '#198754'}} />
              <div className="mt-3 text-muted">Carregando mensagens...</div>
            </div>
          ) : mensagens.length === 0 ? (
            <div className="text-center py-5">
              <div style={{fontSize: '4rem', opacity: '0.3', marginBottom: '16px'}}>💬</div>
              <h6 style={{color: '#757575', fontWeight: '300'}}>Nenhuma mensagem pronta cadastrada</h6>
              <p style={{color: '#9e9e9e', margin: '0'}}>Adicione sua primeira mensagem usando o formulário acima</p>
            </div>
          ) : (
            <div className="table-responsive">
              <Table className="mb-0" style={{fontSize: '13px'}}>
                <thead style={{backgroundColor: '#f8f9fa'}}>
                  <tr>
                    <th style={{padding: '12px 16px', fontWeight: '600', color: '#495057', borderRight: '1px solid #dee2e6'}}>
                      Conteúdo da Mensagem
                    </th>
                    <th style={{padding: '12px 16px', fontWeight: '600', color: '#495057', width: '120px', textAlign: 'center'}}>
                      Ações
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {mensagens.map((mensagem, index) => (
                    <tr key={index} style={{borderBottom: '1px solid #f0f0f0'}}>
                      <td style={{padding: '12px 16px', borderRight: '1px solid #dee2e6', verticalAlign: 'top'}}>
                        <div style={{
                          background: 'linear-gradient(135deg, #e8f5e8 0%, #c8e6c9 100%)',
                          padding: '12px',
                          borderRadius: '6px',
                          borderLeft: '3px solid #198754',
                          fontSize: '13px',
                          lineHeight: '1.4',
                          wordBreak: 'break-word',
                          maxHeight: '120px',
                          overflowY: 'auto'
                        }}>
                          {mensagem.conteudo}
                        </div>
                        <div className="mt-2">
                          <small className="text-muted">
                            {mensagem.conteudo?.length || 0} caracteres
                            {mensagem.conteudo?.includes('*') && <Badge bg="info" className="ms-2 small">Formatação</Badge>}
                            {mensagem.conteudo?.includes('$') && <Badge bg="warning" className="ms-1 small">Variáveis</Badge>}
                          </small>
                        </div>
                      </td>
                      <td style={{padding: '12px 16px', textAlign: 'center', verticalAlign: 'middle'}}>
                        <div className="d-flex flex-column gap-1">
                          <Button
                            variant="outline-primary"
                            size="sm"
                            onClick={() => copiarMensagem(mensagem.conteudo)}
                            style={{fontSize: '11px', padding: '4px 8px'}}
                          >
                            📋 Copiar
                          </Button>
                          <Button
                            variant="outline-danger"
                            size="sm"
                            onClick={() => deletarMensagem(mensagem, index)}
                            style={{fontSize: '11px', padding: '4px 8px'}}
                          >
                            🗑️ Excluir
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          )}
        </div>

        {/* Dicas de Uso */}
        {mensagens.length > 0 && (
          <div className="bg-white p-3 mt-3" style={{border: '1px solid #dee2e6'}}>
            <h6 className="mb-3" style={{color: '#198754', fontWeight: '600'}}>💡 Dicas de Uso</h6>
            <Row>
              <Col md={6}>
                <ul className="small text-muted mb-0">
                  <li><strong>Formatação:</strong> Use *texto* para negrito, _texto_ para itálico</li>
                  <li><strong>Variáveis:</strong> Use $nomePaciente, $dataAgendamento, etc.</li>
                </ul>
              </Col>
              <Col md={6}>
                <ul className="small text-muted mb-0">
                  <li><strong>Copiar:</strong> Clique em "Copiar" para usar em outros lugares</li>
                  <li><strong>Organização:</strong> Mantenha mensagens curtas e objetivas</li>
                </ul>
              </Col>
            </Row>
          </div>
        )}
      </Container>
    </div>
  );
}

export default MensagensProntasView;